export default "__VITE_ASSET__PlwZLDSX__"